import * as React from 'react';

import { connect } from 'react-redux';

import styled from 'styled-components';

import { CallHistoryMethodAction, push } from 'connected-react-router';
import { Dispatch } from 'redux';
import Success from '@components/success';
import AppState from '@webapp/store/state';
import { getMainDomain } from '@webapp/utils/get-artist-site-url';

interface MerchCreateSuccessPageProps {
  continueToMerchPage: (baseUrl: string) => CallHistoryMethodAction | void;
  baseUrl: string;
}

const mapStateToProps = (state: AppState) => {
  const subdomain =
    state.subdomain.currentSubdomain?.subdomain ||
    state.artist.active?.shortId ||
    '';
  return {
    isMobile: state.ui.mobile,
    baseUrl: `https://${subdomain}.${getMainDomain()}/`,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    continueToMerchPage: (baseUrl: string) => {
      window.open(`${baseUrl}merch`, '_blank');
      dispatch(push(`/catalog?type=merch`));
    },
  };
};

const MerchCreateSuccessPage: React.FC<MerchCreateSuccessPageProps> = ({
  continueToMerchPage,
  baseUrl,
}) => {
  return (
    <Success
      HEADING={'SUCCESS.MERCH.CREATE.HEADING'}
      DESCRIPTION={'SUCCESS.MERCH.CREATE.DESCRIPTION'}
      CONTINUE={'SUCCESS.MERCH.CREATE.CONTINUE'}
      continueTo={() => continueToMerchPage(baseUrl)}
      autoRedirectOff={true}
      redirectShortlyTextOff={true}
    />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(MerchCreateSuccessPage)`
  margin-top: 40px;
  padding-bottom: 200px;
  ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
    margin-top: 80px;
  }
`);
